<span class="tooltip-wrapper" placement="bottom" [ngbTooltip]="options.tooltipMessage" #tooltip="ngbTooltip">
    <button class="btn ml-2"
            [ngClass]="options.cssClass || 'btn-primary'"
            [disabled]="loading || options.disabled"
            [ngbPopover]="popContent"
            #popOver="ngbPopover"
            placement="bottom"
            triggers="manual"
            role="button"
            popoverClass="fixed-nav-popover"
            (click)="clickedButton()"
            [appTestId]="options.dataTestSelector || ''"
            [attr.aria-label]="options.ariaLabel">
    <span *appLoadingIndicator="{
                  show: loading || false,
                  message: options.message || 'Downloading...'}">
        <i class="text-decoration-none fa"
           [ngClass]="[options.icon && (options.iconPlacement === iconPlacement.LEFT || options.iconPlacement === undefined) ? options.icon : '']"
           aria-hidden="true"></i>
      {{ options.text }}
      <i class="text-decoration-none fa" [ngClass]="[options.icon && (options.iconPlacement === iconPlacement.RIGHT) ? options.icon : '']"
         aria-hidden="true"></i>
    </span>
</button>
</span>

<ng-template #popContent>
  <div *ngFor="let childButton of options.childButtons">
    <button class="btn btn-sm w-100 ml-2"
            [attr.data-test-selector]="childButton.dataTestSelector ?? ''"
            [ngClass]="childButton.cssClass"
            (click)="applyChildButtonAction(childButton)">
            <span>
                {{ childButton.text }}
            </span>
    </button>
  </div>
</ng-template>
